import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { ProjectService } from 'src/app/_services/project/project.service';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import { ProjectResourcesService } from 'src/app/_services/projectResources/project-resources.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-myparameters',
  templateUrl: './myparameters.component.html',
  styleUrls: ['./myparameters.component.scss']
})
export class MyparametersComponent implements OnInit {

  tenantId: string;
  currentProjectId: any;
  selectedProject: any;
  userDropdownList = [];
  getUserName: any;
  isPMOLeadORManager: boolean = false;
  currentUser: any;
  
  myParametersForm: FormGroup = new FormGroup({
    adasLevel: new FormControl(null),
    archived: new FormControl('false'),
    brand: new FormControl(""),
    competitors: new FormControl(""),
    createdBy: new FormControl(null),
    createdDatetime: new FormControl(new Date().toISOString()),
    currentModel: new FormControl(""),
    customer: new FormControl("", Validators.required),
    decisionDate: new FormControl(null),
    drivetrain: new FormControl(null),
    endDate: new FormControl(null, Validators.required),
    eop: new FormControl(""),
    hasRearQuarterGlass: new FormControl(''),
    lifecycleVolume: new FormControl("",Validators.pattern('^[0-9]*$')),
    lifecycles: new FormControl(""),
    market: new FormControl(""),
    marketPositioning: new FormControl(""),
    modelYear: new FormControl(null, [Validators.min(1900), Validators.max(2199)]),
    modifiedBy: new FormControl(null),
    modifiedDatetime: new FormControl(null),
    platform: new FormControl(""),
    productionSites: new FormControl(""),
    projectCode: new FormControl("",Validators.compose([Validators.required,Validators.pattern('^[0-9]*$')])),
    projectController: new FormControl("",[Validators.required]),
    projectDescription: new FormControl(""),
    projectEnterMs: new FormControl(""),
    projectManager: new FormControl("",[Validators.required]),
    projectManagerId: new FormControl(),
    projectName: new FormControl("",[Validators.required]),
    propulsionType: new FormControl(null),
    quotationDate: new FormControl(null),
    quotationManager: new FormControl(""),
    rearEndConfiguration: new FormControl(null),
    rfqDate: new FormControl(null),
    roughBudgetIndication: new FormControl(""),
    salesManager: new FormControl(""),
    seatCapacity: new FormControl(),
    seatingRows: new FormControl(),
    segment: new FormControl(""),
    sop: new FormControl(""),
    startDate: new FormControl(null,[Validators.required]),
    steeringWheelConfiguration: new FormControl(null),
    tradeAreaCode: new FormControl(null),
    vehicalType: new FormControl(null),
    projectStatus: new FormControl(),
    totalHours: new FormControl(),
    remainingHours: new FormControl(),
    percentWorkCompleted: new FormControl('')
  })

  constructor(
    private router: Router,
    private storageService: LocalStorageService,
    private projectService: ProjectService,
    private route: ActivatedRoute,
    private allocationService: AllocationService,
    private projectResourcesService: ProjectResourcesService,
    private snackBar: MatSnackBar,
  ) { }

// getter for easy access to form fields
get f() {
  return this.myParametersForm.controls;
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.currentProjectId = this.route.snapshot.queryParamMap.get('projectID');

    if (this.currentProjectId) this.getParameterById(this.currentProjectId)
    this.getUserList();
  }
  


  updateorcreateParameters() {
    // if(this.isPMOLeadORManager === true){
      if(this.myParametersForm.value) {
        this.myParametersForm.value.projectManagerId = parseInt(this.myParametersForm.value.projectManager.toString().split(".")[0].trim());
        this.myParametersForm.value.projectManager = this.myParametersForm.value.projectManager.toString().split(".")[1].trim();
      }
  
      if (this.currentProjectId) {
        this.projectService.updateProject(this.currentProjectId, this.myParametersForm.value).subscribe(response => {
          this.myParametersForm.value.projectManager = this.myParametersForm.value.projectManagerId + " . " + this.myParametersForm.value.projectManager;
          this.backToMyProject()
        }, error => {
            this.openSnackBar('ERROR: cannot update project: ' + error);
        });
      } else {
        this.projectService.createProject(this.myParametersForm.value).subscribe((response: any) => {
          this.myParametersForm.value.projectManager = this.myParametersForm.value.projectManagerId + " . " + this.myParametersForm.value.projectManager;
          //this.createProjectResource(response.id);
          this.backToMyProject();
        }, error => {
          this.openSnackBar('ERROR: cannot create project: ' + error);
        });
      }
    // }
    // else{
    //   this.openSnackBar('Please contact your Project manager/lead to update deatils.');
    // }
  }

  // Pop-up message
  openSnackBar(message: string) {
    this.snackBar.open(message, 'Close', { duration: 3000 });
  }

  // createProjectResource(projectId) {
  //   if(this.myParametersForm.get('projectManager').value != null){
  //     if(this.myParametersForm.get('projectManager').value.split(' . ').length === 2){
  //       let details = {
  //         projectId : projectId,
  //         userId : this.myParametersForm.get('projectManager').value.split(' . ')[0],
  //         userName : this.myParametersForm.get('projectManager').value.split(' . ')[1],
  //         projectRole: "Manager",
  //         projectAdminBoolean: true,
  //         startDate: this.myParametersForm.get('startDate').value,
  //         endDate: this.myParametersForm.get('endDate').value,
  //       }
  //       this.projectResourcesService.createprojectResources(details).subscribe((response: any) => {
  //        });
  //     }
  //   }

  //   if(this.myParametersForm.get('projectController').value != null){
  //     if(this.myParametersForm.get('projectController').value.split(' . ').length === 2){
  //       let detailsLead = {
  //         projectId : projectId,
  //         userId : this.myParametersForm.get('projectController').value.split(' . ')[0],
  //         userName : this.myParametersForm.get('projectController').value.split(' . ')[1],
  //         projectRole: "Lead",
  //         projectAdminBoolean: true,
  //         startDate: this.myParametersForm.get('startDate').value,
  //         endDate: this.myParametersForm.get('endDate').value,
  //       }
  //       this.projectResourcesService.createprojectResources(detailsLead).subscribe((response: any) => {
  //       });
  //     }
  //   }
  // }

  getParameterById(id) {
    this.projectService.getProject(id).subscribe((response: any) => {
      if (response) {
        this.myParametersForm.patchValue(response);
        this.myParametersForm.value.projectManager = this.myParametersForm.value.projectManagerId + " . " + this.myParametersForm.value.projectManager;
        this.myParametersForm.patchValue(this.myParametersForm.value);

        let lead = this.currentUser.id + " . " + this.currentUser.firstName + " " + this.currentUser.lastName;
        let creater = this.currentUser.firstName + " " + this.currentUser.lastName;
        let createrFullName = this.currentUser.firstName + " " + this.currentUser.middleName + " " + this.currentUser.lastName;
        if(this.myParametersForm.value.projectManagerId === this.currentUser.id || response.projectController === lead || response.createdBy === creater || response.createdBy === createrFullName){
          this.isPMOLeadORManager = true;
        }
      }
    }, error => {
      this.openSnackBar('ERROR: cannot get project by id: ' + error);
    })
  }

  openProjectTab(param) {
    this.router.navigate([this.tenantId + `/dashboard/project/project-list/${param}`], { queryParams: { projectID: this.currentProjectId } }); // pass current project id as parameter
  }

  backToMyProject() {
    this.router.navigate([this.tenantId + '/dashboard/project/project-list/myproject']);
  }

  getUserList() {
    this.userDropdownList = [];
    this.allocationService.getUserDetails().subscribe((response) => {
      this.getUserName = response;
      for (let item of response) {
        this.userDropdownList.push(
          `${item.id} . ${item.firstName} ${item.lastName}`
        );
      }
    });
  }
}
